module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/uzemniPlanovani-35aa4c4945913f5a0c7c4ed6bd26143a.svg";